import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-row',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-row{display:flex;align-items:stretch;margin-bottom:20px}.mcrai-row:last-child{margin-bottom:0}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-row]': 'true'
  }
})
export class RowComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
